<script setup lang="ts">
import NavigationHeader from './components/navigation/NavigationHeader.vue'
import Breadcrumbs from './components/shared/Breadcrumbs.vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/useAuthStore'
import { storeToRefs } from 'pinia'

const route = useRoute()
const authStore = useAuthStore()
const { isAuthResolved } = storeToRefs(authStore)
</script>

<template>
  <v-app>
    <!-- Show nothing until auth is resolved -->
    <div v-if="isAuthResolved">
      <div class="newnav">
        <NavigationHeader />
      </div>
      <div class="main-content">
        <div class="container">
          <!-- Breadcrumbs: only show if NOT frontpage -->
          <Breadcrumbs v-if="route.path !== '/'" />

          <router-view />
        </div>
      </div>
    </div>
    <!-- Optional: Show loading state while checking auth -->
    <div v-else class="auth-loading">
      <v-progress-circular indeterminate color="primary" />
    </div>
  </v-app>
</template>

<style lang="scss">

    .main-content{
      margin: auto;
    }

    .container{
      max-width: 1440px;
      margin: auto;
    }

    .row {
        flex-wrap: nowrap;
        margin-left: 7%;
        margin-right: 7%;

        @media(max-width: 992px) {
            margin-right: 35px;
            margin-left: 35px;
            flex-wrap: wrap;
            justify-content: center;
        }
    }

    .newnav {
        min-width: 256px;
    }

    @media(max-width: 992px) {
        .container {
            padding: 12px;

            .main-content {
                padding: 0;
            }
        }
    }

    .main-content {
        padding: 12px;
        width: 100%;

        @media(max-width: 992px) {
            padding: 0;
        }
    }

    .auth-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        width: 100vw;
    }
</style>